let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("g4FYy"), load("tLGOl")]).then(() => parcelRequire('anKEx'));